import {
    ConfigService,
    CustomInjector,
    EscalationService,
    EventService,
    NotificationModel,
    NotificationService,
} from '@evorait/pace-core';
import { Subscription } from 'rxjs';
import { AlertService } from '../../../core/services/eta-alert/alert.service';

export enum DASHBOARD_TAB {
    TODAYS,
    UPCOMING,
    NEW,
}
export class DashboardModel {
    public todaysAssignments: NotificationModel[];
    public upcomingAssignments: NotificationModel[];
    public newAssignments: NotificationModel[];

    private notificationsUpdated: Subscription;

    private notificationService: NotificationService;
    private escalationService: EscalationService;
    private alertService: AlertService;
    private configService: ConfigService;
    public constructor() {
        const injector = CustomInjector.getInjector();
        const eventService = injector.get(EventService);
        this.notificationService = injector.get(NotificationService);
        this.escalationService = injector.get(EscalationService);
        this.alertService = injector.get(AlertService);
        this.configService = injector.get(ConfigService);
        this.notificationsUpdated = eventService.notificationsUpdated$.subscribe(() => this.updateNotifications());

        this.updateNotifications();
    }

    private updateNotifications(): void {
        this.todaysAssignments = this.notificationService.getTodaysNotifications();
        this.upcomingAssignments = this.notificationService.getUpcomingNotifications();
        this.newAssignments = this.notificationService.getNewNotifications();

        // check if any notification is in progress and set the timer accordingly to raise the escalation alert
        this.escalationService.checkEscalationRequired();
        if (this.configService.getDisplayEtaAlert()) {
            this.alertService.checkEtaAlertRequired();
        }
    }

    /**
     * De-register event listeners on rootScope
     */
    public destroy(): void {
        if (typeof this.notificationsUpdated !== 'undefined') {
            this.notificationsUpdated.unsubscribe();
        }
    }
}
